import React from 'react';
import { Card, Col, Container, Placeholder, Row } from 'react-bootstrap';

function SkeletonBlock({ height = 18, className = '' }) {
  return (
    <Placeholder
      as="div"
      animation="glow"
      className={`rounded ${className}`}
      style={{ height }}
    >
      <Placeholder xs={12} />
    </Placeholder>
  );
}

export default function LandingSkeleton() {
  return (
    <>
      <section className="remote-hero">
        <Container className="remote-hero__container">
          <Row className="align-items-center gy-5">
            <Col lg={5}>
              <div className="remote-hero__content">
                <SkeletonBlock height={70} className="mb-3" />
                <SkeletonBlock height={20} className="mb-2" />
                <SkeletonBlock height={20} className="mb-2" />
                <SkeletonBlock height={20} className="mb-4" />
                <SkeletonBlock height={54} className="mb-4 w-50" />
                <SkeletonBlock height={18} className="mb-2 w-25" />
                <SkeletonBlock height={52} className="w-50" />
              </div>
            </Col>

            <Col lg={7}>
              <div className="remote-hero__visual skeleton-visual">
                <Card className="w-100 h-100 border-0 bg-transparent">
                  <Card.Body className="h-100 d-flex flex-column justify-content-center">
                    <SkeletonBlock height={36} className="mb-4 w-75 mx-auto" />
                    <SkeletonBlock height={36} className="mb-4 w-50 mx-auto" />
                    <SkeletonBlock height={36} className="w-75 mx-auto" />
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="landing-section">
        <Container>
          <Row className="g-4">
            {Array.from({ length: 6 }).map((_, index) => (
              <Col xl={4} md={6} key={index}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body className="p-4">
                    <SkeletonBlock height={44} className="mb-3 w-25" />
                    <SkeletonBlock height={28} className="mb-3 w-75" />
                    <SkeletonBlock height={16} className="mb-2" />
                    <SkeletonBlock height={16} className="mb-2" />
                    <SkeletonBlock height={16} className="mb-4 w-75" />
                    <SkeletonBlock height={14} className="mb-2" />
                    <SkeletonBlock height={14} className="mb-2" />
                    <SkeletonBlock height={14} className="mb-2" />
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="landing-section">
        <Container>
          <Row className="g-4">
            {Array.from({ length: 3 }).map((_, index) => (
              <Col xl={4} md={6} key={index}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body className="p-4">
                    <SkeletonBlock height={22} className="mb-3 w-50" />
                    <SkeletonBlock height={72} className="mb-3" />
                    <SkeletonBlock height={72} />
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="landing-section">
        <Container>
          <Row className="g-4">
            {Array.from({ length: 3 }).map((_, index) => (
              <Col xl={4} md={6} key={index}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body className="p-4">
                    <SkeletonBlock height={20} className="mb-3 w-25" />
                    <SkeletonBlock height={44} className="mb-3 w-50" />
                    <SkeletonBlock height={18} className="mb-4 w-50" />
                    <SkeletonBlock height={14} className="mb-2" />
                    <SkeletonBlock height={14} className="mb-2" />
                    <SkeletonBlock height={14} className="mb-4" />
                    <SkeletonBlock height={48} />
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="landing-section">
        <Container>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <SkeletonBlock height={22} className="mb-3 w-50" />
              <SkeletonBlock height={50} className="mb-3" />
              <SkeletonBlock height={50} className="mb-3" />
              <SkeletonBlock height={50} />
            </Card.Body>
          </Card>
        </Container>
      </section>

      <section className="landing-final-cta">
        <Container>
          <div className="landing-final-cta__inner">
            <SkeletonBlock height={38} className="mb-3 w-50 mx-auto" />
            <SkeletonBlock height={18} className="mb-2 w-75 mx-auto" />
            <SkeletonBlock height={18} className="mb-4 w-50 mx-auto" />
            <SkeletonBlock height={50} className="w-25 mx-auto" />
          </div>
        </Container>
      </section>
    </>
  );
}